<template lang="pug">
#LoginPage
    loadingOverlay(v-show='loading' message='Loading . . .' :zIndex='999')
    #login-gpt
        .login-page-gpt.pt-5.pt-md-1()
            v-container.fluid.pa-0.hidden-sm-and-down(style="margin-top:80px;")
                v-row.no-gutters.d-flex.justify-center
                    v-col(cols="5" class="bg-panel") 
                        img.logo.mx-auto.d-block(src="@/assets/images/TSC-logo.png" alt="TSCLogo")
                        .welcome-text
                            h2 Welcome back!
                            p.tagline
                                | Ready to start an amazing conversation with TSC?
                    //- 右側表單
                    v-col(cols="7" class="form-panel")
                        v-card.flat.login-card(style="border-radius:15px!important;")
                            v-card-text
                                p.primary-login.text-center LOGIN
                                form
                                    //- v-text-field.text-input.mb-3(
                                    //-     v-model="username"
                                    //-     :label="$t('LOGIN.ACCOUNT')"
                                    //-     prepend-inner-icon="mdi-account"
                                    //- )
                                    //- v-text-field.text-input.mb-3(
                                    //-     v-model="password"
                                    //-     :type="showPassword ? 'text' : 'password'"
                                    //-     :label="$t('LOGIN.PWD')"
                                    //-     prepend-inner-icon="mdi-lock"
                                    //-     :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                    //-     @click:append="togglePassword"
                                    //- )
                                    v-text-field.text-input.mb-2(
                                        v-model="tenant"
                                        :label="'Tenant'"
                                        prepend-inner-icon="mdi-domain"
                                    )
                                    .text-right(style="margin-bottom:100px;")
                                        //- a.forget(@click='forgetPassword = true') {{$t('FORGET_PASSWORD.TITLE')}}
                                    input.btn.primary-btn.w-100.py-3(type="submit", :value=`'LOGIN'` @click='handleLogin($event)')
            //- 手機板
            v-container.fluid.pa-0.hidden-md-and-up
                v-row.no-gutters.justify-center
                    v-col(cols="12" class="form-panel-mobile")
                        img.logo-mobile(src="@/assets/images/TSC-logo.png" alt="TSCLogo")
                        v-card.flat.rounded-lg.login-card-mobile(style="border-radius:15px!important;")
                            v-card-text.pa-0
                                p.primary-mobile-login.text-center LOGIN
                                form
                                    //- v-text-field.text-input.mb-3(
                                    //-     v-model="username"
                                    //-     :label="$t('LOGIN.ACCOUNT')"
                                    //-     prepend-inner-icon="mdi-account"
                                    //- )
                                    //- v-text-field.text-input.mb-3(
                                    //-     v-model="password"
                                    //-     :type="showPassword ? 'text' : 'password'"
                                    //-     :label="$t('LOGIN.PWD')"
                                    //-     prepend-inner-icon="mdi-lock"
                                    //-     :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                    //-     @click:append="togglePassword"
                                    //- )
                                    v-text-field.text-input.mb-2(
                                        :class='displayNone ? "d-none" : ""'
                                        v-model="tenant"
                                        :label="'Tenant'"
                                        prepend-inner-icon="mdi-domain"
                                    )
                                    //- .text-right
                                    //-     p.forget(@click='forgetPassword = true') Forget Password
                                    input.btn.primary-btn.w-100.py-3(type="submit", :value=`'LOGIN'` @click='handleLogin($event)')
        //- footer.footer
        //-     nav.py-md-2.py-5.text-center
        //-         p.d-inline ART Solutions All Rights Reserved.
        //-         span.mx-2 | 
        //-         a.text-decoration-underline(href="/DPF.pdf" target="_blank") Data Processing Agreement
    v-dialog(v-model='forgetPassword' max-width='500')
        forgetPassword-dialog(@emitForgetPasswordDialog='onEmitForgetPasswordDialog' @emitForgetPasswordSuccess='onEmitForgetPasswordSuccess')
    v-dialog(v-model='successDialog' width='360' content-class='statusDialog' @keydown.enter='onEmitSuccessDialog()')
        success-dialog(@emitSuccessDialog='onEmitSuccessDialog')
    v-dialog(v-model='errorDialog' width='360' content-class='statusDialog')
        error-dialog(@emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage')
    v-dialog(v-model='messageDialog' width='360' content-class='statusDialog')
        message-dialog(@emitMessageDialog='onEmitMessageDialog' :message='message')
</template>
<script>
import { mapActions } from 'vuex';
import successDialog from "@/components/Dialog/successDialog";
import errorDialog from "@/components/Dialog/errorDialog";
import messageDialog from "@/components/Dialog/messageDialog";
import loadingOverlay from "@/components/Common/loadingOverlay";
import forgetPasswordDialog from "@/components/Dialog/User/forgetPasswordDialog";
import passData from "@/services/passData.js";
import i18n from '/common/plugins/vue-i18n.js' 
    export default {
        name: "Sso-UpGPT-Login",
        components: {
            errorDialog,
            successDialog,
            messageDialog,
            loadingOverlay,
            forgetPasswordDialog,
            passData
        },
        data() {
            return{
                loading: false,
                tenant: '',
                username: '',
                password: '',
                loginValiCode: '',
                showPassword: false,
                forgetPassword: false,
                noneusername:false,
                nonetenant:false,
                successDialog: false,
                errorDialog: false,
                errorMessage: '',
                messageDialog: false,
                message: '',
                displayNone: false,
                displayLoginVali: false,
                changePassword:false,
                nextPath: '/upgpt',
            }
        },
        mounted() {
            this.updateAfterLoginNextPath();
        },
        created() {
            window.addEventListener('keyup', this.close)

            let nowPath = this.$router.currentRoute.fullPath;
            let test = 'sso-upgpt-login?tenant=';
            let nullTenant = 'tenant=null';
            if(nowPath.includes(test) && !nowPath.includes(nullTenant)){
                let query_params = nowPath.slice(nowPath.indexOf(test) + test.length);
                if(query_params.includes('&'))
                    this.tenant = query_params.split('&')[0];
                else
                    this.tenant = query_params;
                this.displayNone = true;
 
            }
            let user = JSON.parse(window.localStorage.getItem('user'));
            if(user != null)
            {
                let is_portal_user = user['is_portal_user'] || false;
                this.changePassword = user.change_password;
                if(this.changePassword){
                    if(window.location.href.includes('next=') && window.location.href.includes('upgpt_portal') && is_portal_user){
                        this.$router.replace('/UpGPT_Portal');    
                    }else if(window.location.href.includes('next=') && window.location.href.includes('upgpt_portal') && !is_portal_user){
                        this.$router.replace('/upgpt/PermissionErrorPortal'); 
                    }else{
                        this.$router.replace('/upgpt/UserSetting/');                    
                    }
                }
                else{
                    let nextToPath = this.nextPath;
                    if (window.location.href.includes('next=')) {
                        let urlNext = decodeURIComponent(window.location.href.split('next=')[1]);
                        nextToPath = urlNext;
                    }
                    this.$router.replace(nextToPath);
                }
            }
        },
        methods: {
            togglePassword() {
                this.showPassword = !this.showPassword
            },
            onEmitForgetPasswordDialog(val) {
                this.forgetPassword = val;
            },
            onEmitForgetPasswordSuccess(val,errorMsg) {
                if(val){
                    this.forgetPassword = false;
                    this.successDialog = true;
                }else{
                    this.errorDialog = true;
                    this.errorMessage = errorMsg;
                }
            },
            updateAfterLoginNextPath() {	  
                if ('next' in this.$route.query) {
                    this.nextPath = this.$route.query.next;		
                }	 
            },
            onEmitSuccessDialog() {
                this.successDialog = false;
            },
            onEmitErrorDialog(val) {
                if(val){
                    this.errorDialog = false;
                }
            },
            handleLogin(event) {
                event.preventDefault();
                if (this.tenant == '')
                {
                    this.errorDialog = true;
                    this.errorMessage = i18n.t('LOGIN.ERROR_2');
                }
                else
                {
                    let tenant = this.tenant.toLowerCase();
                    this.loading = true;
                    this.loginSsoUpGptUser({ tenant: tenant, loginValiCode: this.loginValiCode, needRedirect: true })
                    .then((redirectPath) => {
                        this.loading = false;
                        this.$emit('loginSuccess');
                        window.location.assign(redirectPath);
                        var user = JSON.parse(window.localStorage.getItem('user'));
                        if(user) {
                            this.changePassword = user.change_password;
                        }
                        if (window.location.href.includes('next=') && window.location.href.includes('upgpt_portal')){
                            this.forwardToUpGPTPage();   
                        }
                        else if(user && user.upchat_sso_link != '')
                        {
                            window.location.href = user.upchat_sso_link;
                        }
                        else
                        {
                            this.forwardToUpGPTPage();
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                        this.errorDialog = true;
                        if(error.response){
                            this.errorMessage = i18n.t('LOGIN.ERROR_3');
                        } else if (typeof error === 'string' && error === 'Incorrect login information') {
                            this.errorMessage = i18n.t('LOGIN.ERROR_5');
                        }
                    })
                    .finally(() => {
                        passData.$emit("status");
                        passData.$emit("upchat",window.localStorage.getItem('isUpchatUser'));
                    })
                }
            },
            forwardToUpGPTPage(){
                if(this.changePassword)
                {
                    let user = JSON.parse(window.localStorage.getItem('user'));
                    if(user != null){
                        let is_portal_user = user['is_portal_user'] || false;
                        if(window.location.href.includes('next=') && (window.location.href.includes('UpGPT_Portal') || window.location.href.includes('upgpt_portal')) && is_portal_user){
                            this.$router.replace('/UpGPT_Portal');    
                        }else if(window.location.href.includes('next=') && (window.location.href.includes('UpGPT_Portal') || window.location.href.includes('upgpt_portal')) && !is_portal_user){
                            this.$router.replace('/upgpt/PermissionErrorPortal'); 
                        }else{
                            this.$router.replace('/upgpt/UserSetting/')
                        }
                    }
                }
                else
                {
                    let user = JSON.parse(window.localStorage.getItem('user'));
                    if (user != null){
                        let nextToPath = this.nextPath;
                        if (window.location.href.includes('next=')){
                            let urlNext = decodeURIComponent(window.location.href.split('next=')[1]);
                            nextToPath = urlNext;
                        }
                        if(window.location.href.includes('next=') && window.location.href.includes('upgpt_portal')){
                            nextToPath = '/UpGPT_Portal'
                        }
                        this.$router.replace(nextToPath);
                    }
                }
            },
            onEmitMessageDialog(val) {
                this.messageDialog = false;
                console.log('onEmitMessageDialog: ' + val);
            },
            ...mapActions([
                'loginUpGptUser',
                'loginSsoUpGptUser',
            ]),
            close(ev){
                if(this.errorDialog && ev.key == "Enter")
                {
                    if((this.tenant != ''&& !this.noneusername) | this.nonetenant )
                    {
                        this.errorDialog = false
                        this.nonetenant = false
                    }else
                    {
                        this.nonetenant = true
                    }
                }   
            },
        }
    }
</script>

<style lang="scss" scoped>
    #login-gpt{
        background-image: url("~@/assets/images/bg-upgpt-login.jpg");
        background-size: cover;
        background-position: top;
        background-repeat: no-repeat;
        min-height: 100dvh;
        height: 100dvh;
    }
    .login-page-gpt {
        // padding-top: 100px;
        position: relative;
    }
    .primary-login{
        font-size: 36px;
        font-weight: 500;
        color: #222;
    }
    .bg-panel {
        position: relative;
        padding: 64px;
        .logo {
          width: 300px;
          margin-top: 30px;
          margin-bottom: 60px;
        }
        .welcome-text{
            color: #044958;
            text-align: center;
            h2 {
                font-size: 36px;
                margin-bottom: 36px;
            }
            .tagline {
                font-size: 28px;
                color: #1095AF;
                line-height: 1.5;
                font-weight: 500;
                
            }
        }
        .v-card{
            border-radius: 15px !important;
        }
    }
    .primary-mobile-login{
        font-size: 28px;
        font-weight: 500;
        color: #222;
    }
    .form-panel,
    .form-panel-mobile {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 32px;

        .login-card,
        .login-card-mobile{
            width: 90%;
            max-width: 500px;
            padding: 24px;
            border-radius: 15px !important;
        }
        .logo-mobile {
            width: 160px;
            margin: 25px auto 32px;
        }
        .forget {
            font-size: 0.875rem;
            color: #00acc1;
            text-decoration: none;
        }
        .v-card__text{
            line-height: unset;
        }
    }
    .footer {
        position: absolute;
        bottom: 0px;
        width: 100%;
        color: #546e7a;
        font-size: 0.75rem;
        background-color: rgba(255, 255, 255, 0.4);
        nav a {
            color: inherit;
            text-decoration: none;
        }
        nav span {
            color: #b0bec5;
        }
    }
    .theme--light.v-sheet{
        background-color: rgba(255, 255, 255, 0.2) !important;

        box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
        backdrop-filter: blur(8.8px);
        -webkit-backdrop-filter: blur(8.8px);
        border: 1.5px solid rgba(255, 255, 255, 0.3);
    }
    .theme--light.v-input input,.theme--light.v-input textarea{
        font-size: small;
    }
    .primary-btn{
        color: white;
        background-color: #14C6DE;
        border-radius: 50px;
    }
</style>
